<template>
  <fragment>
    <v-content>
      <v-container fluid grid-list-xl :class="currentStepData.class">
        <v-flex xs12>
          <form-alert
            :type="alertText.type"
            :message="alertText.message"
            @close="closeFormAlert"
          />
        </v-flex>

        <v-layout row wrap>
          <v-flex xs12>
            <jns-step-puzzle
              :step-user-is="currentStepData.id"
              :steps="formSteps"
              @click="() => {}"
              no-navegation
            />
          </v-flex>
        </v-layout>

        <v-form
          ref="endorsementForm"
          class="white_background no-gutter"
          @submit.prevent="onSubmit"
        >
          <v-layout row wrap v-if="policy && !loading">
            <component
              :is="currentStep"
              :policy="policy"
              :importancia-segurada-model="importanciaSeguradaModel"
              :vigencia-model="vigenciaModel"
              @update-is="updateISValue"
              @update-fim-vigencia="updateFimVigencia"
              @update-inicio-vigencia-is="updateInicioVigenciaIS"
              @on-update-objeto-tag="onUpdateObjetoTag"
              @toggle-section="toggleSection"
              @select-installment="onSelectInstallment"
              @select-dias-primeira-parcela="onSelectDiasPrimeiraParcela"
            />
          </v-layout>

          <v-footer class="proposta__footer" fixed>
            <v-btn
              class="jns-button width-auto white-button"
              @click="desistir()"
            >
              Desistir
            </v-btn>
            <v-spacer></v-spacer>
            <div>
              <v-btn
                type="submit"
                class="jns-button width-auto yellow-button"
                :disabled="cantProgress"
              >
                {{ advanceButtonText }} <v-icon>arrow_right_alt</v-icon>
              </v-btn>
            </div>
          </v-footer>
        </v-form>
      </v-container>
    </v-content>

    <v-dialog
      v-model="step.state.dialogResumoProposta"
      persistent
      v-if="Boolean(policy)"
    >
      <v-card>
        <v-container grid-list-xl class="no-padding">
          <v-card-title class="ml-0 pl-0 pt-5 pb-4">
            <h2>Resumo da Proposta</h2>
          </v-card-title>

          <proposta-expandida-informacoes
            :tomador="policy.tomador"
            :segurado="policy.segurado"
            :modalidades="policy.modalidades"
            :coberturas="[latestCoverage]"
            :objeto="policy.objeto"
          />
          <v-card-actions class="pt-4 pb-3">
            <v-btn
              class="jns-button width-auto white-button"
              @click="closeResume"
            >
              Voltar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="jns-button width-auto yellow-button"
              @click="onSubmit"
            >
              Solicitar Análise
              <v-icon>arrow_right_alt</v-icon>
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="step.state.submittingEndorsementProposal"
      v-model="step.state.submittingEndorsementProposal"
      persistent
      max-width="700"
    >
      <base-modal>
        <processo-solicitacao-proposta
          :process="autoApprovalProcess"
          @goto="goto"
        >
          <template v-slot:steps>
            <v-layout row wrap>
              <process-list-item
                v-for="(step, index) in autoApprovalSteps"
                :key="index"
                :process="{
                  status: autoApprovalProcess.status,
                  error: autoApprovalProcess.error,
                  text: step,
                }"
              />
            </v-layout>
          </template>
        </processo-solicitacao-proposta>
      </base-modal>
    </v-dialog>

    <v-dialog max-width="400" v-model="showConfirmDialog">
      <base-modal>
        <h3 class="mb-3 text-center">Tem certeza que deseja desistir?</h3>
        <v-layout row class="justify-center">
          <v-flex md4 sm6>
            <button class="button jns-button white-button" @click="goToApolice">
              Desistir
            </button>
          </v-flex>
          <v-flex md4 sm6>
            <button
              class="button jns-button yellow-button"
              @click="showConfirmDialog = false"
            >
              Fechar
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </fragment>
</template>

<script lang="js">
import _ from "lodash";
import moment from "moment";
import { mapActions } from "vuex";
import { policyAutoApprovalStep } from "@/libs/autoApprovalProcessSteps.js";
import PropostaMixin from "@/mixins/PropostaMixin";
import ViewMixin from "@/mixins/ViewMixin";
import Steps from "@/components/Apolice/Steps";
import EndorsementStepController from "@/mixins/EndorsementStepController.js";
import ProcessoSolicitacaoProposta from "@/components/Apolice/Steps/ProcessoSolicitacaoProposta.vue";
import ProcessListItem from "@/components/Apolice/Steps/ProcessListItem.vue";
import { getObjectTags, setObject, updateObjectWithTagValues, prepareObjetoText } from "@/libs/objectTags";
import { PROGRESS, ERRO, DONE } from "@/components/Apolice/Steps/AutomaticApproval.js";

export default {
  name: "Endossar",
  mixins: [ViewMixin, PropostaMixin, EndorsementStepController],
  components: {
    ...Steps.components,
    ProcessoSolicitacaoProposta,
    ProcessListItem
  },
  props: ["endorsement"],
  data() {
    return {
      Steps,
      formSteps: _.map(Steps, ({ step }) => step),
      policy: null,
      importanciaSeguradaModel: null,
      vigenciaModel: null,
      processSteps: policyAutoApprovalStep(),
      running: false,
      state: {
        stack: [],
        current: null,
        error: null
      },
      loading: false,
      selectedInstallment: null,
      selectedDiasPrimeiraParcela: null,
      autoApprovalProcess: {
        status: false,
        error: null,
        text: "Aprovação automática"
      },
      autoApprovalSteps: [
        "Aprovação automática de crédito",
        "Aprovação automática de subscrição",
        "Aprovação automática de resseguro",
      ],
      showConfirmDialog: false,
      isValidObjetoTag: false,
      id_endosso: null,
    };
  },
  mounted() {
    this.endorsement && this.changeStep({ step: "CommissionForm" });
    this.fetchData();
  },
  computed: {
    isISSelected() {
      return Boolean(this.importanciaSeguradaModel);
    },
    isVigenciaSelected() {
      return Boolean(this.vigenciaModel);
    },
    latestCoverage() {
      const principalModality = this.policy.modalidades.principal;
      const coverage = {
        ...this.policy.coberturas.find(
          c => c.nome === principalModality
        )
      };

      let [ inicio_vigencia, fim_vigencia, importancia_segurada ] = this.computeISVigenciaFromModel();
      coverage.inicio_vigencia = inicio_vigencia.format("L");
      coverage.inicio_vigencia_formatted = inicio_vigencia.format("L");
      coverage.fim_vigencia = fim_vigencia.format("L");
      coverage.fim_vigencia_formatted = fim_vigencia.format("L");
      coverage.importancia_segurada = importancia_segurada;

      return coverage;
    },
    cantProgress() {
      return !(this.stepValidation(this) && this.isObjetoTagsValidInStepInformacoesApolice);
    },
    advanceButtonText() {
      return this.isEmissionStep ? "Emitir endosso" : "Avançar";
    },
    isEmissionStep() {
      return this.step.step === "PremioEComissao";
    },
    isPolicyInformationStep() {
      return this.step.step === "InformacoesDaApolice" && !this.step.state.dialogResumoProposta && !this.step.state.submittingEndorsementProposal;
    },
    isObjetoTagsValidInStepInformacoesApolice(){
      return this.isValidObjetoTag || !this.isPolicyInformationStep;
    }
  },
  methods: {
    ...mapActions({
      "createEndorsement": "POST_ENDORSEMENT",
      "automaticApproval": "GET_AUTO_APPROVAL_ENDORSEMENT",
    }),

    toggleIS() {
      const { importancia_segurada } = this.policy.coberturas[0];
      this.importanciaSeguradaModel =
        this.isISSelected ? null : {
          valor: importancia_segurada,
          inicio_vigencia: null
        };
      this.vigenciaModel =
        this.isVigenciaSelected ? this.computeVigencia() : null ;
    },

    computeVigencia(){
      const { inicio_vigencia } = this.policy;
      const inicio_vigencia_endosso = this.importanciaSeguradaModel?.inicio_vigencia ?? this.inicioVigenciaEndossoPadrao(this.policy)
      return {
          inicio_vigencia_apolice: moment(inicio_vigencia),
          inicio_vigencia: moment(inicio_vigencia_endosso),
          fim_vigencia: null
        };
    },

    toggleVigencia() {
      this.vigenciaModel =
        this.isVigenciaSelected ? null : this.computeVigencia();
    },

    toggleSection(section) {
      const table = {
        "is": this.toggleIS,
        "vigencia": this.toggleVigencia
      }[section]();
    },

    closeResume(){
      this.previousStep();
    },

    resetScroll() {
      document.querySelector(".white_background").scrollTo(0, 0);
      this.$forceUpdate();
    },

    updateISValue(value) {
      this.importanciaSeguradaModel.valor = value;
    },

    updateInicioVigenciaIS(value) {
      this.importanciaSeguradaModel.inicio_vigencia = moment(value);
      if (this.vigenciaModel) this.vigenciaModel.inicio_vigencia = moment(value);
    },

    updateFimVigencia(value) {
      this.vigenciaModel.fim_vigencia = moment(value);
    },

    onUpdateObjetoTag(){
      this.isValidObjetoTag = this.policy.objeto_tags.every(tag => tag.value);
    },

    stepperChangeStep({ step }) {
      this.stepValidation(this) && this.changeStep(step);
    },

    async sync() {
      await (new Promise(r => setTimeout(() => r(), 2000)));
      return await this.$nextTick();
    },

    inicioVigenciaEndossoPadrao(apolice) {
      return moment(apolice.fim_vigencia)
    },

    computeISVigenciaFromModel(){
      let inicio_vigencia = this.importanciaSeguradaModel?.inicio_vigencia ?? this.inicioVigenciaEndossoPadrao(this.policy);
      let fim_vigencia = this.vigenciaModel?.fim_vigencia ?? moment(this.policy.fim_vigencia);
      let importancia_segurada = this.importanciaSeguradaModel?.valor ?? this.policy.coberturas[0].importancia_segurada;
      return [inicio_vigencia, fim_vigencia, importancia_segurada];
    },

    makeDocument(endorsementStatus) {
      const [inicio_vigencia, fim_vigencia, importancia_segurada] = this.computeISVigenciaFromModel();
      let document = {
        cd_apolice: this.policy.id_apolice,
        id_endosso_referencia: this.policy.id_endosso,
        fim_vigencia: fim_vigencia.format("YYYY-MM-DD"),
        inicio_vigencia: inicio_vigencia.format("YYYY-MM-DD"),
        status: endorsementStatus,
        importancia_segurada,
        objeto: prepareObjetoText(this.policy.objeto),
         // Estrutura utilizada na emissão direta pegando id de data
        ...(this.id_endosso && { id_endosso: this.id_endosso }),
        // Estrutura utilizada na emissão a partir da lista de endossos, pegando o id da prop
        ...(this.endorsement && { id_endosso: this.endorsement.id_endosso }),
      };
      return document;
    },
    desistir() {
      this.showConfirmDialog = true;
    },

    goToApolice() {
      const { apoliceId } = this.$route.params;
      this.$router.push(`/apolice/${apoliceId}`);
    },

    goto(section) {
      section === "next-step" ? this.nextStep() : this.goToApolice();
    },

    onSubmit() {
      this.isPolicyInformationStep && updateObjectWithTagValues(this.policy);
      this.$refs.endorsementForm.validate()
        && this.stepValidation(this)
        && (this.execStepAction() || this.nextStep());
    },

    onSelectInstallment(installment) {
      this.selectedInstallment = installment;
    },

    onSelectDiasPrimeiraParcela(diasPrimeiraParcela) {
      this.selectedDiasPrimeiraParcela = diasPrimeiraParcela;
    },

    async fetchData() {
      try {
        this.loading = true;
        this.showLoadingIndicator();
        const { apoliceId } = this.$route.params;
        this.policy = await this.$store.dispatch("GET_POLICY", {
          apoliceId
        });
        const { objeto } = await this.$store.dispatch("GET_POLICY_OBJECT", { apoliceId });
        this.policy.objeto = objeto;
        this.policy.objeto_tags = getObjectTags(this.policy);
        setObject(this.policy);
        // esse acesso ao id_endosso é diferenten porque quando vai da lista direto para o passo 2 temos o endorsement como prop
        this.endorsement && await this.getPremium(this.endorsement.id_endosso);
      } catch (e) {
        this.setErrorModal(e.response.data);
      } finally {
        this.loading = false;
        this.hideLoadingIndicator();
      }
    },
    async makeEndorsement(){
      await this.insertEndorsement();
      await this.analyzeEndorsement();
      await this.getPremium(this.id_endosso);
    },

    async insertEndorsement() {
      this.showLoadingIndicator();
      const payload = this.makeDocument("INSERIR");
      try {
        const response = await this.createEndorsement(payload);
        if (response.cd_retorno) throw { message: response.nm_retorno.split(":")[1].trim() };
        this.id_endosso = response.id_endosso_gerado;
        this.nextStep();
      } catch (error) {
        this.setErrorModal(error.response.data);
      } finally {
        this.hideLoadingIndicator();
      }
    },

    async analyzeEndorsement() {
      this.autoApprovalProcess.status = PROGRESS;
      const payload = this.makeDocument("ANALISAR");
      try {
        const response = await this.createEndorsement(payload);
        if (response.message) throw { message: response.message };
        this.autoApprovalProcess.status = DONE;
      } catch (error) {
        this.autoApprovalProcess.error = error.message || "Aprovação automática falhou.";
        this.autoApprovalProcess.status = ERRO;
      }
    },

    async emitEndorsement() {
      this.showLoadingIndicator();
      const { apoliceId } = this.$route.params;
      const payload = this.makeDocument("GERAR");

      payload.parcelamento = [
        {
          vl_premio_total: this.selectedInstallment.detalhes.premio_total,
          nr_parcela: this.selectedInstallment.nr_parcelas,
          qt_total: this.selectedInstallment.detalhes.valor_parcela,
          vl_adicional: this.selectedInstallment.detalhes.adicional_fracionamento_parcela,
          dias_vencimento_primeira_parcela: this.selectedDiasPrimeiraParcela,
          id_produto_parc_premio: this.selectedInstallment.id_produto_parc_premio

        }
      ];

      try {
        await this.createEndorsement(payload);
        this.alertText = this.handleAlertText2("Endosso emitido com sucesso", "success");
        this.$router.push({ path: `/apolice/${apoliceId}` });
      } catch (error) {
        this.setErrorModal(error.response.data);
      } finally {
        this.hideLoadingIndicator();
      }
    },

    async getPremium(endossoId) {
      try {
        this.showLoadingIndicator();
        const { apoliceId } = this.$route.params;
        const premiumComissionInstallments = await this.$store.dispatch("GET_ENDORSEMENT_PREMIUM", { apoliceId, endossoId});
        _.merge(this.policy, premiumComissionInstallments);
        // sem esses atributos setados o passo 2 quebra
        this.selectedInstallment = this.policy.parcelamentos_disponiveis[0];
        this.selectedDiasPrimeiraParcela = this.policy.parametros.dias_vencimento_primeira_parcela[0]
      } catch (e) {
        this.setErrorModal(error.response.data);
      } finally {
        this.hideLoadingIndicator();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
#jns {
  .proposta__footer {
    padding-left: 99px;
    padding-right: 20px;
    height: 76px !important;
  }
  .text-center {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Apolices/Endossar.vue